<template>
  <div>
    <header-Assembly ref="header" @headerChange="headerChange" :generatingCapacityList="generatingCapacityList"></header-Assembly>
    <div class="content">
      <!-- <notice></notice> -->
      <power-Generation
        ref="powerGeneration"
        :environmentalTestingList="environmentalTestingList"
        :environmentalTesting="environmentalTesting"
      ></power-Generation>
      <!-- <hidden-danger :hiddenDangerList="hiddenDangerList"></hidden-danger> -->
      <middle :powerStationList="powerStationList"></middle>
      <work-Order :grewList="grewList"></work-Order>
      <comparison-Chart :generatingCapacityList="generatingCapacityList"></comparison-Chart>
    </div>
    <audio-video-alarm :audioVideoAlarm="audioVideoAlarm"></audio-video-alarm>
    <change-shifts ref="changeShifts"></change-shifts>
    <fireWarning ref="fireWarning"></fireWarning>
  </div>
</template>

<script>
import headerAssembly from '@/components/header'
import hiddenDanger from '@/components/hiddenDanger'
import comparisonChart from '@/components/comparisonChart'
import powerGeneration from '@/components/powerGeneration'
import middle from '@/components/middle'
import workOrder from '@/components/workOrder'
import audioVideoAlarm from '@/components/audioVideoAlarm'
import changeShifts from '@/components/changeShifts'
import fireWarning from '@/components/fireWarning'
// import notice from '@/components/notice'
let _self
export default {
  data() {
    return {
      websock: null,
      antiShakeSwitch: false,//报警防抖开关
      generatingCapacityList: 0,
      environmentalTestingList: 0,
      hiddenDangerList: 0,
      powerStationList: 0,
      grewList: 0,
      heartMessage: 'I am alive',
      timeout: 50 * 1000, //  心跳检测时长
      sendTimeoutObj: null, // 发送定时变量
      dosendTimeoutObj: null, // 接收定时变量
      audioVideoAlarm: null, // 接收定时变量
      heartCheck: {
        reset: function () {
          // 重置定时
          clearTimeout(_self.sendTimeoutObj)
          clearTimeout(_self.dosendTimeoutObj)
          return this
        },
        start: function () {
          // 开启定时
          _self.sendTimeoutObj = setTimeout(function () {
            // 发送心跳
            _self.websocketsend(_self.heartMessage)
          }, _self.timeout)

          _self.dosendTimeoutObj = setTimeout(function () {
            // 心跳时间内收不到消息，主动触发连接关闭，开始重连
            _self.websock.close()
          }, _self.timeout + 10000) // 加十秒用来等待接收服务端心跳消息
        }
      }
    }
  },
  destroyed() {
    this.websock.close() //离开路由之后断开websocket连接
  },
  created() {
    _self = this
    this.initWebSocket()
  },
  methods: {
    initWebSocket() {
      //初始化weosocket
      // const wsuri = 'ws://127.0.0.1:8899/ws'
      // const wsuri = 'ws://39.108.58.156:8899/ws'
      const wsuri = 'ws://58.16.134.114:48924/ws'
      //const wsuri = "ws://120.79.243.63:8899/ws";
      // const wsuri = "ws://58.16.134.114:48972/ws";
      this.websock = new WebSocket(wsuri)
      this.websock.onmessage = this.websocketonmessage
      this.websock.onopen = this.websocketonopen
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose
    },
    websocketonopen() {
      //连接建立之后执行send方法发送数据
      //let actions = { "test": "open" };
      //this.websocketsend(JSON.stringify(actions));
      _self.websocketsend('big-screenONLINE')
      _self.heartCheck.reset().start()
      console.log('连接成功')
    },
    websocketonerror() {
      //连接建立失败重连
      _self.reconnect()
    },
    websocketonmessage(e) {
      //数据接收

      _self.heartCheck.reset().start()
      if ('copy that' == e.data) {
        return
      }
      if ('exit' == e.data) {
        console.log('后台退出 开启重连')
        _self.reconnect()
        return
      }
      var that = this
      console.log(e)
      const redata = e.data || ''
      if (redata.startsWith('generatingCapacity')) {
        that.generatingCapacityList = that.generatingCapacityList + 1
        that.grewList = that.grewList + 1
      } else if (redata.startsWith('powerStation')) {
        that.powerStationList = that.powerStationList + 1
        that.environmentalTestingList = that.environmentalTestingList + 1
        that.generatingCapacityList = that.generatingCapacityList + 1
      } else if (redata.startsWith('grew')) {
        that.grewList = that.grewList + 1
      } else if (redata.startsWith('environmentalTesting')) {
        let objStr = redata.replace(/^environmentalTesting:/, '')
        let parse = JSON.parse(objStr)
        this.$refs.powerGeneration.environmentalTesting(parse)
      } else if (redata.startsWith('hiddenDanger')) {
        that.hiddenDangerList = that.hiddenDangerList + 1
      } else if (redata.startsWith('audioVideoAlarm')) {
        //音视频报警
        let objStr = redata.replace(/^audioVideoAlarm:/, '')
        let parse = JSON.parse(objStr)
        that.audioVideoAlarm = parse
      } else if (redata.startsWith('noStationShift')) {
        that.$refs.changeShifts.initData()
      }else if (redata.startsWith('sceneLink')) {
        let objStr = redata.replace(/^sceneLink:/, '')
        let parse = JSON.parse(objStr)
        if(this.antiShakeSwitch){
          return
        }
        this.antiShakeSwitch = true;
        let _self = this;
        setTimeout(function(){
          _self.antiShakeSwitch = false;
        },50000);
        //大屏预警
        parse['countDown'] = 50;
        parse['index'] = Math.random();
        that.$refs.fireWarning.initData(Object.assign(parse))
        let headerData = Object.assign(parse);
        // headerData['countDown'] = 0;
        that.$refs.header.initData(headerData)
      }
    },
    headerChange(val){
      this.$refs.fireWarning.initData(val)
    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data)
    },
    websocketclose(e) {
      //关闭
      console.log('断开连接', e)
      this.reconnect()
    },
    reconnect() {
      if (_self.reconnect.lockReconnect) return
      _self.reconnect.lockReconnect = true
      setTimeout(function () {
        //没连接上会一直重连，设置延迟避免请求过多
        _self.initWebSocket()
        _self.reconnect.lockReconnect = false
      }, 10000)
    }
  },
  components: {
    headerAssembly,
    comparisonChart,
    powerGeneration,
    middle,
    workOrder,
    audioVideoAlarm,
    hiddenDanger,
    changeShifts,
    fireWarning
  }
}
</script>

<style>
body {
  background: linear-gradient(to right, #021326 0%, #0f3050 60%, #021326 100%);
  height: 100%;
}

.content {
  display: flex;
  margin-top: 1%;
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue